<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{$t('CreatePage.createDevice')}}</span>                        
                <el-button class="rightButton" @click="goBack">{{$t('CreatePage.backButton')}}</el-button>
            </div>           
                       
            <el-form class="form-box" :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="80px">
                <div class="formTitle">
                    <span>{{$t('CreatePage.baseInfo')}}</span>                        
                </div>                     
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.company')" prop="company">
                            <el-select v-model="ruleForm.company" class="formWidth" :placeholder="$t('Message.select')" @change="((key)=>{changeCompany(key)})">
                                <el-option v-for="item in companySelect" :key="item.sssid" :label="item.nickname" :value="item.sssid"></el-option>
                            </el-select>                             
                        </el-form-item>                          
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.group')" prop="group">
                            <el-select v-model="ruleForm.group" class="formWidth" :placeholder="$t('Message.select')" :disabled="groupDisable">
                                <el-option v-for="item in groupSelect" :key="item.sssid" :label="item.trackergroupname" :value="item.sssid"></el-option>
                            </el-select>                              
                        </el-form-item>  
                    </el-col>    
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.deviceSeries')" prop="deviceSeries">
                            <el-select v-model="ruleForm.deviceSeries" class="formWidth" :placeholder="$t('Message.select')" @change="((key)=>{changeSeries(key)})">
                                <el-option v-for="item in seriesSelect" :key="item.seriesid" :label="item.seriesname" :value="item.seriesid"></el-option>
                            </el-select>                              
                        </el-form-item>  
                    </el-col>                       
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.mode')" prop="mode">
                            <el-select v-model="ruleForm.mode" class="formWidth" :placeholder="$t('Message.select')" :disabled="modeDisable">
                                <el-option v-for="item in modeSelect" :key="item.modelid" :label="item.modelname" :value="item.modelid"></el-option>
                            </el-select>                              
                        </el-form-item>  
                    </el-col>                       
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.deviceName')" prop="deviceName">
                            <el-input v-model="ruleForm.deviceName" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.imei')" prop="imei">
                            <el-input v-model="ruleForm.imei" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.sn')" prop="sn">        
                            <el-input v-model="ruleForm.sn" class="formWidth"></el-input>
                        </el-form-item>  
                    </el-col>                        
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.firmwareVer')" prop="firmwareVer">
                            <el-input v-model="ruleForm.firmwareVer" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.configFile')" prop="configFile">
                            <el-input v-model="ruleForm.configFile" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 预留 -->
                <!-- <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.securityFile')" prop="securityFile">
                            <el-input v-model="ruleForm.securityFile" class="formWidth"></el-input>                            
                        </el-form-item>  
                    </el-col>                        
                </el-row>                 -->
                
                <!-- 连接参数先注释 -->
                <!-- <div class="formTitle">
                    <span>{{$t('CreatePage.paramSetting')}}</span>                        
                </div>                     
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.ip')" prop="ip">
                            <el-input v-model="ruleForm.ip" class="formWidth"></el-input>
                        </el-form-item>                         
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.port')" prop="port">
                            <el-input v-model="ruleForm.port" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>    
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.cntFOTAfrequency')" prop="cntFOTAfrequency">
                            <el-input v-model="ruleForm.cntFOTAfrequency" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>                                     
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <div class="mt30">
                            <span class="font-set mr10">{{$t('DeviceManage.cntFOTAfunciton')}}</span>
                            <el-switch v-model="ruleForm.cntFOTAenabled"></el-switch>  
                        </div>
             
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('DeviceManage.alarmClock')" prop="alarmClock">
                            <el-input v-model="ruleForm.alarmClock" class="formWidth"></el-input>
                        </el-form-item>
                    </el-col>                                      
                </el-row> -->

                <el-form-item class="buttonCenter">
                    <el-button type="primary" @click="onSubmit('ruleForm')">{{$t('Button.submit')}}</el-button>
                    <el-button @click="goBack">{{$t('Button.back')}}</el-button>
                </el-form-item>                   
            </el-form>


        </div>


    </div>
</template>

<script>
import bus from '../../common/bus';
import Tools from '../../common/Tools';
import api from '../../../api/api.js';
import apiAllSystem from '../../../api/apiAllSystem.js';

export default {
    name: 'taskCreate',
    components: { 

    },     
    data() {
        return {
            labelPosition: "top",
            pagesize: 10, //每页显示条数
            curPage: 1,   //当前页数         
            multipleSelection: [],
            ruleForm: {
                company: "",
                group: "",
                mode: "",
                deviceSeries: "",
                deviceName: "",
                imei: "",
                sn: "",
                firmwareVer: "",
                configFile: "",
                securityFile: "",
                ip: "",
                port: "",
                cntFOTAfrequency: "",
                cntFOTAenabled: true,
                alarmClock: "",
            },
            companySelect: [],
            groupSelect: [],
            modeSelect: [],
            seriesSelect: [],
            tableData: [],
            loading: false,
            autoMatch: true,
            modeDisable: true,
            groupDisable: true
        };
    },
    
    computed: {
        rules() {
            return {
                company: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                ],
                group: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                ],
                mode: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                ],
                deviceSeries: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                ],        
                imei: [
                    { required: true, message: this.$t('Rules.require'), trigger: 'blur'},
                    { type: "string", pattern: /^\d{15}$/, message: this.$t('Rules.IMEI'), trigger: 'blur'},
                ],                                    
                sn: [
                    { type: "string", pattern: /^\d{11}$/, message: this.$t('Rules.sn'), trigger: 'blur'},
                ],
                deviceName: [
                    { type: "string", pattern: /^[\u4E00-\u9FA5a-zA-Z0-9]+([_-][\u4E00-\u9FA5a-zA-Z0-9]+)*$/, min: 2, max: 20, message: this.$t('Rules.name'), trigger: 'blur'},
                ],
                firmwareVer: [
                    { type: "string", pattern: /^[(]?[a-zA-Z0-9]+([-_~.()][a-zA-Z0-9]+)*[)]?$/, message: this.$t('Rules.firmwareVer'), trigger: 'blur'},
                ],                
                configFile: [
                    { type: "string", pattern: /^[(]?[a-zA-Z0-9]+([-_~.()][a-zA-Z0-9]+)*[)]?$/, message: this.$t('Rules.configFile'), trigger: 'blur'},
                ],          
            }
        }
    },
    created() {
        this.getCompany();
        this.getSeries();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },      
        getCompany() {
            let params = {
                usersssid: localStorage.getItem('sssid')
            };
            api.getUser(params)
            .then(res => {
                if(res.state){
                    this.companySelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });             
        },
        getGroup(key) {
            let params = {
                usersssid: key
            };
            api.getTrackerGroup(params)
            .then(res => {
                if(res.state){
                    this.groupSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });              

        },          
        getSeries() {
            api.getTrackerSeries()
            .then(res => {
                if(res.state){
                    this.seriesSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })

        },                       
        getMode(key) {
            let params = {
                seriesid: key
            };
            api.getTrackerModels(params)
            .then(res => {
                if(res.state){
                    this.modeSelect = res.value;
                } else {
                    this.$message.error(res.value.text);
                }

            })

        }, 

        onSubmit(formName) {     
            this.$refs[formName].validate((valid) => {
                if (valid) {     
                    let param = {
                        usersssid: this.ruleForm.company,
                        groupsssid: this.ruleForm.group,
                    };
                    let params = { 
                        modeltype: this.ruleForm.mode,
                        seriestype: this.ruleForm.deviceSeries,
                        trackername: this.ruleForm.deviceName,
                        imei: this.ruleForm.imei,
                        sn: this.ruleForm.sn,
                        firmware: this.ruleForm.firmwareVer,
                        optionfile: this.ruleForm.configFile,
                        // securityFile: this.ruleForm.securityFile,

                        // ip: this.ruleForm.ip,
                        // port: this.ruleForm.port,
                        // cntFOTAfrequency: this.ruleForm.cntFOTAfrequency,
                        // cntFOTAenabled: this.ruleForm.cntFOTAenabled,
                        // alarmClock: this.ruleForm.alarmClock
                    };
                    
                    api.creatTracker(param, params)
                    .then(res => {
                        if(res.state){
                            this.$message.success(this.$t('Message.success'));
                            this.$router.push({path:'/deviceManage', query:{detail: res.value.text}});
                        } else {
                            this.$message.error(res.value.text);
                        }
                        
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('Message.reqError'));
                    });  
                }
            })                                                  
 
        },

        changeSeries(key) {
            this.modeDisable = false;
            this.ruleForm.mode = "";
            this.modeSelect = [];
            this.getMode(key);
        },

        changeCompany(key) {
            this.groupDisable = false;
            this.getGroup(key);
        }

    }
};
</script>

<style scoped>

</style>